'use client';

import flush from 'just-flush';
import { keyFiguresSection } from '@stereoagency/sanity-schema';
import { KeyFiguresSection as UIKeyFiguresSection } from '@stereoagency/ui';

type Props = typeof keyFiguresSection.schema.keyFiguresSection;

export default function KeyFiguresSection({
  title,
  subtitle,
  figures,
}: Props) {
  if (!figures?.length) {
    return null;
  }

  const figuresProp = flush(figures.map((fig) => {
    if (!fig.label || !fig.count) {
      return null;
    }

    return {
      count: fig.count,
      label: fig.label,
      suffix: fig.suffix,
    };
  }))

  return (
    <UIKeyFiguresSection
      title={title}
      subtitle={subtitle}
      figures={figuresProp}
    />
  );
}
